/**
 * Build-time switch for the Email button.
 *
 * Off by default: the button hands governed figures to a mail client the app
 * does not control, so a deployment opts in deliberately.
 */

export interface EmailDraftConfig {
  enabled: boolean;
}

function flag(value: unknown): boolean {
  return typeof value === "string" && ["1", "true", "yes", "on"].includes(
    value.trim().toLowerCase(),
  );
}

export function emailDraftConfig(
  env: Record<string, unknown> = import.meta.env,
): EmailDraftConfig {
  return { enabled: flag(env.VITE_EMAIL_DRAFT_ENABLED) };
}
